module.exports = __webpack_public_path__ + "static/img/20260905-01.54dda5c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/20260905-01.webp
// module id = T8S5
// module chunks = 1